<template>
  <v-dialog
    v-model="associateDialog"
    width="max-content"
    content-class="elevation-0"
  >
    <v-row class="ma-0 pa-0">
      <v-col>
        <v-card class="pb-2 px-2 rounded-20" width="550px">
          <v-card-title class="mb-1">
            <h2 class="title-h2">Associate Gauge Kit</h2>
          </v-card-title>
          <v-form ref="form" @submit.prevent="handleContinue">
            <v-row class="pa-0 ma-0 align-center my-5">
              <v-text-field
                v-model="serialNumber"
                :autofocus="true"
                outlined
                dense
                hide-details
                label="Serial Number"
                class="rounded-10"
                :rules="rules"
                @change="invalidKitNumber = false"
              />

              <v-btn
                class="btn-primary ml-3 rounded-10"
                width="120px"
                @click="handleContinue"
              >
                <span v-if="!loading"> Continue </span>
                <v-progress-circular v-if="loading" size="28" indeterminate />
              </v-btn>
            </v-row>
          </v-form>
          <v-alert :value="alertVisible" color="error" dark dense>
            <v-icon class="mr-3"> mdi-alert </v-icon>
            {{ alertMessage }}
          </v-alert>
          <div>
            The Kit Serial Number can be found on the top left hand corner of
            the Kit Box, as shown below:
          </div>
          <v-img
            :src="require('@/assets/gauge-kit-serial-no.png')"
            max-width="300px"
            class="my-3"
            contain
          />
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import client from "@/lib/ApiClient"
import { mapActions } from "vuex"

export default {
  name: "AssociateScanGaugeKitDialog",

  props: ["value"],

  data() {
    return {
      loading: false,
      rules: [(v) => !!v, (v) => /^[0-9]+$/.test(v)],
      invalidKitNumber: false,
      alertVisible: false,
      alertMessage: null,
      serialNumber: null
    }
  },

  computed: {
    associateDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.serialNumber = null
        this.$emit("input", value)
      }
    }
  },

  methods: {
    ...mapActions(["triggerReload"]),

    async handleContinue() {
      if (!this.$refs.form.validate() || this.loading)
        return this.showAlert(
          "Please enter a valid serial number before continuing"
        )
      try {
        this.loading = true

        const payload = {
          serial_number: this.serialNumber
        }

        const response =
          await client.gateway.gaugeKits.associateGaugeKitToClient(payload)
        if (response) this.associateDialog = false
        this.triggerReload("scanGaugeKits")
      } catch {
        this.showAlert(
          "Could not associate gauge kit using the submitted serial number"
        )
      }
      this.loading = false
    },

    showAlert(message) {
      this.alertVisible = true
      this.alertMessage = message
    }
  }
}
</script>
